import { PATH } from "./constants";



export const sideBarNavigation = Object.values(PATH.privateRoutes)
  .filter((x) => x?.sidebar?.show)
  .map((pageData, index) =>
    pageData.children
      ? {
        id: index + 1,
        path: pageData.path,
        ...(
          pageData?.button ? {
            button: pageData?.button
          } : {}
        ),
        icon: pageData.sidebar.icon,
        children: pageData.children.filter((x) => x?.sidebar?.show),
        pageName: pageData.sidebar.name || pageData.pageName,
        permissionName: pageData.permissionName,
      }
      : {
        id: index + 1,
        path: pageData.path,
        ...(
          pageData?.button ? {
            button: pageData?.button
          } : {}
        ),
        icon: pageData.sidebar.icon,
        pageName: pageData.sidebar.name || pageData.pageName,
        permissionName: pageData.permissionName,
      }
  );
